export default "__VITE_ASSET__ko_IBZLR__";